import { Component } from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { profile as profilePropType } from 'redux/prop-types/authentication';
import glossaryPropType from 'redux/prop-types/glossary';

import {
  loadGlossary,
  shouldLoadGlossary,
  setGlossary,
} from 'redux/reducers/glossary';
import userCanEdit from 'helpers/userCanEdit';

class GlossaryData extends Component {
  static propTypes = {
    /** Load the glossary from the key/value store */
    loadGlossary: func.isRequired,
    /** Check if the glossary should be loaded */
    shouldLoadGlossary: func.isRequired,
    /** Save edited glossary items to the key/value store */
    setGlossary: func.isRequired,
    /** The user profile */
    profile: profilePropType,
    /** Glossary content and loading/success states */
    glossary: glossaryPropType.isRequired,
    /** Glossary content render function */
    children: func.isRequired,
  };

  componentDidMount() {
    if (this.props.shouldLoadGlossary()) {
      this.props.loadGlossary();
    }
  }

  render() {
    const {
      glossary,
      setGlossary,
      profile,
      children: renderChildren,
    } = this.props;

    return renderChildren({
      glossary,
      setGlossary,
      userCanEdit: userCanEdit(profile),
    });
  }
}

export default connect(
  (state) => ({
    profile: state.authentication.profile,
    glossary: state.glossary,
  }),
  {
    loadGlossary,
    shouldLoadGlossary,
    setGlossary,
  }
)(GlossaryData);
